import React, { useEffect, useRef } from 'react';
import './AudioVisualizer.css';

export function IdleAudioVisualizer() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;
    const centerX = width / 2;
    const centerY = height / 2;

    const innerRadius = Math.min(centerX, centerY) * 0.2;
    const bufferSpace = Math.min(centerX, centerY) * 0.5;
    const numRings = 3;

    ctx.clearRect(0, 0, width, height);

    // Central faded circle
    ctx.beginPath();
    ctx.fillStyle = '#e5e7eb'; // light gray
    ctx.arc(centerX, centerY, innerRadius, 0, Math.PI * 2);
    ctx.fill();

    // Static gray rings
    for (let i = 1; i <= numRings; i++) {
      const radius =
        innerRadius +
        (i * (Math.min(centerX, centerY) - innerRadius - bufferSpace)) /
          numRings;
      ctx.beginPath();
      ctx.strokeStyle = 'rgba(107, 114, 128, 0.3)'; // Tailwind gray-500 w/ opacity
      ctx.lineWidth = 2;
      ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
      ctx.stroke();
    }
  }, []);

  return (
    <div className="audio-visualizer-container">
      <canvas ref={canvasRef} width={200} height={200} />
    </div>
  );
}
